export default function productMenu() {
    const menu = document.querySelector('[data-menu-product]')
    if (!menu) return
    const nav = document.querySelector('[data-navigation]')
    const links = [...menu.querySelectorAll('a[href^="#"]')]
    const items = links.flatMap((link) => {
        const section = document.getElementById(link.hash.slice(1))
        return section ? [{ link, section }] : []
    })

    const sticky = () => (nav?.offsetHeight || 0) + menu.offsetHeight

    const sync = () => {
        const viewTop = sticky()
        const viewBottom = window.innerHeight
        const viewH = viewBottom - viewTop
        if (viewH <= 0) return
        items.forEach(({ link, section }) => {
            const rect = section.getBoundingClientRect()
            const visible = Math.min(rect.bottom, viewBottom) - Math.max(rect.top, viewTop)
            const ratio = visible / Math.min(rect.height, viewH)
            link.classList.toggle('active', ratio >= 0.8)
        })
    }

    let ticking = false
    const onScroll = () => {
        if (ticking) return
        ticking = true
        requestAnimationFrame(() => {
            sync()
            ticking = false
        })
    }

    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            const section = document.getElementById(link.hash.slice(1))
            if (!section) return
            e.preventDefault()
            const top = section.getBoundingClientRect().top + window.scrollY - sticky()
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
        })
    })

    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    sync()
}
